import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Target, Award } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useLanguage } from '@/contexts/LanguageContext';

export const AboutSection = () => {
  const { t, language } = useLanguage();

  const values = [
  {
    icon: Award,
    title: t('valueExcellenceTitle'),
    description: t('valueExcellenceDesc')
  },
  {
    icon: Target,
    title: t('valueEthicsTitle'),
    description: t('valueEthicsDesc')
  }];

  return (
    <section className="py-24 section-gradient-violet">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
          <div>
            <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-6">
              {t('aboutTitle')}
            </h2>
            <h3 className="text-xl font-semibold mb-4 gradient-text">
              {t('aboutSubtitle')}
            </h3>
            <p className="text-lg text-muted-foreground mb-6 leading-relaxed">
              {t('aboutTeam')}
            </p>
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              {t('aboutMission')}
            </p>
            <h3 className="text-xl font-semibold mb-4 gradient-text">
              {t('aboutWhyGaiusTitle')}
            </h3>
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              {t('aboutWhyGaius')}
            </p>
            <Button asChild size="lg" className="gradient-bg text-primary-foreground hover:opacity-90 glow-primary">
              <Link to="/formations-eligibles-financements" className="flex items-center space-x-2">
                <span>{language === 'fr' ? 'Choisir ma Formation IA juridique' : 'Choose my Legal AI Training'}</span>
                <ArrowRight className="w-5 h-5" />
              </Link>
            </Button>
          </div>
          
          <div className="mt-12 lg:mt-0 space-y-8">
            <div className="w-full rounded-2xl shadow-xl overflow-hidden border border-border/50">
              <img
                src="/images/formation-ia-avocat-chatgpt-droit.webp"
                alt="Formation IA avocat : ChatGPT Claude Gemini pour juristes - formation continue obligatoire FCO CPF FIF-PL OPCO Mon compte formation IA juridique droit"
                title="Formation IA avocat et juriste - ChatGPT, Claude, Gemini pour la pratique du droit | Gaius formation juridique IA"
                loading="lazy"
                decoding="async"
                width={800}
                height={500}
                sizes="(max-width: 1024px) 100vw, 50vw"
                className="w-full h-auto object-cover min-h-[300px] lg:min-h-[420px]" />
            </div>

            <div className="grid grid-cols-1 gap-6">
              {values.map((value, index) =>
              <Card key={index} className="border-l-4 border-l-primary glass-card hover:shadow-xl transition-all duration-300">
                  <CardHeader className="pb-3">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 rounded-xl gradient-bg flex items-center justify-center">
                        <value.icon className="w-5 h-5 text-primary-foreground" />
                      </div>
                      <CardTitle className="text-lg text-foreground">{value.title}</CardTitle>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base text-muted-foreground">
                      {value.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>);
};
